import { render } from "./controller.vue?vue&type=template&id=8e31eda2&ts=true"
import script from "./controller.vue?vue&type=script&lang=ts"
export * from "./controller.vue?vue&type=script&lang=ts"

import "./controller.vue?vue&type=style&index=0&id=8e31eda2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__